import {
  configureApiRuntime,
  createCognitoTokenReader,
} from '@consolidocs-ui/data-access';

// Side-effect module. Imported first in main.tsx so the API layer is configured
// before anything can issue a request. ES imports are hoisted, so a bare call
// in main.tsx would run *after* the store module had already been evaluated.
const getToken = createCognitoTokenReader(
  import.meta.env.VITE_COGNITO_AUTH_AUTHORITY,
  import.meta.env.VITE_COGNITO_AUTH_CLIENT_ID
);

configureApiRuntime({
  default: {
    baseUrl: import.meta.env.VITE_BACKEND_URL,
    getToken,
  },
  ai: {
    baseUrl:
      import.meta.env.VITE_AI_SERVICE_URL || import.meta.env.VITE_BACKEND_URL,
    getToken,
  },
});
